import React from "react";

import { Icon, Position, Tooltip } from "@blueprintjs/core";
import { IViewProps, View } from "core/decorators/View";
import styled from "styled-components";
import LinkViewConfig from "./LinkViewConfig";

/**
 * @overview: Displays a menu link with color, hover, active, icon, etc
 * @author: jesposito
 */

export interface ILinkViewProps extends IViewProps<LinkViewConfig> {
	icon: string;
	active?: boolean;
	vertical?: boolean;
}

@View({id: "menu-link", configClass: LinkViewConfig})
export default class LinkView extends React.PureComponent<ILinkViewProps> {

	public render() {
		const { config, children } = this.props;

		const Cont = styled.div`
			padding: ${config.padding};
			font-size: ${config.labelSize};
			color: ${config.color};
			text-transform: ${config.textTransform};
			font-weight: ${config.fontWeight};

			${this.props.vertical ? `
				border-bottom: ${config.separator};
			` : `
				border-right: ${config.separator};
			`}

			${this.props.active && `
				color: ${config.activeColor};
				background: ${config.activeBackground};
				border-bottom: ${config.activeBorder};
			`}

			&:hover {
				color: ${config.hoverColor};
				text-decoration: none !important;
			}
		`;

		const inner = (
			<React.Fragment>
				{config.showIcon && (
					<Icon icon={this.props.icon as any} iconSize={config.iconSize} />
				)}

				{config.showLabel && (
					children
				)}
			</React.Fragment>
		);

		return (
			<Cont>
				{
					config.showTooltip ? (
						<Tooltip content={children as JSX.Element} position={Position.RIGHT}>
							{inner}
						</Tooltip>
					) : inner
				}
			</Cont>
		);
	}
}





// WEBPACK FOOTER //
// ./src/common/views/menu/Link.view.tsx